import url from '@/assets/js/interface'
export default {
  resourceInfoGetter({ commit }, { vm, fileNames, md5List }) {
    fileNames = fileNames || []
    md5List = md5List || fileNames
    if (fileNames.length === 0) return Promise.resolve()
    return vm.$ajaxJson.post(url.getBatchFileUrl, {
      expiration: 36000000,
      fileNames: fileNames
    }).then(res => {
      let data = vm.$ajaxCheck(res);
      if (!data || !(data instanceof Array)) return
      let result = {}
      data.forEach((v, i) => {
        let s = /\?/.test(v) ? '&' : '?'
        result[md5List[i]] = `${v}${s}r=${Math.random()}`
      })
      commit('setResourceInfoDict', result)
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
  gradeVolumesGetter({ commit }, { vm }) {
    return vm.$ajax.get(url.gradeVolumes).then(res => {
      let data = vm.$ajaxCheck(res)
      let gradeVolumes = []
      data = data || {}
      Object.keys(data).forEach(name => {
        gradeVolumes.push({ name, label: data[name] })
      })
      commit('setGradeVolumeList', gradeVolumes)
    }).catch(err => {
      vm.$ajaxError(err)
    })
  },
}
